import React, { FC, useState } from "react";
import Sidebar from "../../shared/Sidebar/index";
import "./index.css";
import { Col, Row } from "react-bootstrap";
 
interface email {
  email: string;
}
 
const ProfileSetting: FC = () => {
  const email = localStorage.getItem("email") || "";
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <Sidebar />
      <div className="main-cont-header page-titles">
        <Row className="page-header">
          <Col sm={12}>
            <div className="main-con-page-title-container">
              <div className="title">
                <h3 className="page-title">Profile Settings</h3>
              </div>
            </div>
          </Col>
          <Col sm={6} className="main-content-container mt-4">
          
            <label className="lab">First Name</label>
            <input name="text" type="text" className="form-control mb-2" />
            <label className="lab">Last Name</label>
            <input name="text" type="text" className="form-control mb-2" />
            <label className="lab">Email</label>
            <input
              name="email"
              type="email"
              className="form-control mb-2"
              // value="user@example.com"
              value={email}
              readOnly
            />
            <div className="password-wrapper">
              <label className="lab">Password</label>
              <div className="position-relative">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  className="form-control mb-2"
                />
                <i
                  className={`fa ${
                    showPassword ?   "fa-eye" :"fa-eye-slash"
                  } eye-icon`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
            </div>
            <label className="lab">Profile Picture</label>
            <input name="file" type="file" className="form-control mb-2" />
            <div className="d-flex justify-content-end mt-4">
              <button className="btn  btnbbtns">Cancel</button>
              <button type="submit" className="btn btn-primary btnbbtn mx-2">
                Save
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
 
export default ProfileSetting;
 
 